import { useTranslation } from "react-i18next";
import { Chip, Tooltip, makeStyles } from "@material-ui/core";
import {
  StorageNotificationTemplateType,
  TYPE_CONFIGS,
} from "../typeConfig";

const FORM_KEY_BY_TYPE = Object.fromEntries(
  TYPE_CONFIGS.map(tc => [tc.type, tc.formKey])
) as Record<StorageNotificationTemplateType, string>;

type Props = {
  type: StorageNotificationTemplateType;
};

export default function TypeChip({ type }: Props) {
  const classes = useStyles();
  const { t } = useTranslation("storage");
  const formKey = FORM_KEY_BY_TYPE[type];

  return (
    <Tooltip title={t(`notificationTemplates.type.${formKey}.label`)} arrow>
      <Chip size="small" label={t(`notificationTemplates.type.${formKey}.short`)} variant="outlined" color="primary" className={classes.chip} />
    </Tooltip>
  );
}

const useStyles = makeStyles(theme => ({
  chip: {
    height: 20,
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: "0.04em",
    marginRight: 4,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
}));
